import { EcdsaSecp256r1, hexToBinary, } from '@streamr/utils';
import { ScheduleService } from '../schedule/ScheduleService';
const signing = new EcdsaSecp256r1();
/** Signs as the broadcaster whose private key is given. */
export function createRecordingSigner(broadcasterUserId, broadcasterPrivateKey) {
    const jwk = signing.privateKeyToJWK(hexToBinary(broadcasterPrivateKey));
    return {
        userId: broadcasterUserId,
        sign: (payload) => signing.createSignature(payload, jwk),
    };
}
export const verifyBroadcasterSignature = (userId, payload, signature) => signing.verifySignature(hexToBinary(userId), payload, signature);
/**
 * The private key of the stream's broadcaster, if this device holds the
 * broadcast or session: then the user is its host.
 */
export function findBroadcasterPrivateKey(streamId) {
    const schedule = ScheduleService.getInstance();
    return (schedule.getScheduledSession(streamId)?.broadcasterPrivateKey ??
        schedule.getScheduledBroadcast(streamId)?.broadcasterPrivateKey);
}
